import React from 'react';
import {
  Container,
  Paper,
  Title,
  Text,
  Stack,
  Group,
  Button,
  Divider,
  ThemeIcon,
  Box,
  Anchor
} from '@mantine/core';
import { IconAlertTriangle, IconRefresh, IconArrowBack } from '@tabler/icons-react';

interface MsalErrorFallbackProps {
  error?: Error | null;
  resetErrorBoundary?: () => void;
}

export const MsalErrorFallback: React.FC<MsalErrorFallbackProps> = ({
  error,
  resetErrorBoundary
}) => {
  // Support email for your organization
  const supportEmail = "support@yourcompany.com";
  
  const handleRetry = () => {
    if (resetErrorBoundary) {
      resetErrorBoundary();
    } else {
      window.location.reload();
    }
  };
  
  const handleGoToHome = () => {
    window.location.href = '/';
  };

  return (
    <Container size="sm" py="xl">
      <Paper 
        shadow="md" 
        p="xl" 
        radius="md"
        withBorder
      >
        <Stack spacing="md" align="center">
          <ThemeIcon 
            size={80} 
            radius={40} 
            color="orange"
          >
            <IconAlertTriangle size={50} stroke={1.5} />
          </ThemeIcon>
          
          <Title order={2} align="center" mt="md">
            Authentication Service Unavailable
          </Title>
          
          <Text align="center" color="dimmed" size="lg">
            We're having trouble connecting to the authentication service.
            Please try again or contact support if the problem persists.
          </Text>
          
          {error && (
            <Paper 
              withBorder 
              p="md" 
              radius="md" 
              sx={{ width: '100%' }}
            >
              <Text color="dimmed" size="sm">
                Error details:
              </Text>
              <Text color="red" size="sm">
                {error.message || "An unknown error occurred"}
              </Text>
            </Paper>
          )}
          
          <Divider w="100%" my="sm" />
          
          <Group position="center" w="100%">
            <Button
              leftIcon={<IconRefresh size={18} />}
              onClick={handleRetry}
              color="blue"
              radius="md"
            >
              Try Again
            </Button>
            
            <Button
              leftIcon={<IconArrowBack size={18} />}
              onClick={handleGoToHome}
              variant="light"
              radius="md"
            >
              Go to Home
            </Button>
          </Group>
          
          <Box mt="md">
            <Text size="sm" color="dimmed" align="center">
              Need assistance? Contact{' '}
              <Anchor href={`mailto:${supportEmail}`} size="sm">
                {supportEmail}
              </Anchor>
            </Text>
          </Box>
        </Stack>
      </Paper>
    </Container>
  );
}; 